import {scenariosData} from 'data/scenarios-data';
import {
	defaultMaxPoints, 
	defaultMinPoints, 
	errorPenalty, 
	inputAnswerMaxAttempts, 
	inputAnswerMinPoints
} from 'data/points-data';


/**
 * Get tasks of specific scenario
 * @param {string} scenarioId 
 * @returns 
 */
const getScenarioTaskIds = (scenarioId) => {
	let taskIds = [];
	if (
		scenariosData.hasOwnProperty(scenarioId) && 
		scenariosData[scenarioId].hasOwnProperty('tasksData')
	 ) {
		taskIds = scenariosData[scenarioId].tasksData.map((t) => {return t.id;});
	}
	return taskIds;
};

/**
 * Get task data
 * @param {string} scenarioId 
 * @param {string} areaId 
 * @param {number} caseId 
 * @param {number} taskNumber 
 * @returns 
 */
const getTaskData = (scenarioId, taskId) => {
	let taskData = null;
	if (
		scenariosData.hasOwnProperty(scenarioId) && 
		scenariosData[scenarioId].hasOwnProperty('tasksData') &&
		scenariosData[scenarioId].tasksData.some((t) => {return t.id === taskId;})
	 ) {
		taskData = scenariosData[scenarioId].tasksData.find((t) => {return t.id === taskId;});
	}
	return taskData;
};

/**
 * Get player points
 * @param {object} playerData 
 * @returns 
 */
export function getPlayerPoints(playerData) {
	let points = 0;
	if (playerData.assignments && playerData.assignments.length > 0) {
		playerData.assignments.forEach((assignment) => {
			if (assignment.isCompleted && assignment.points) {
				points += assignment.points;
			}
		});
	}

	return points;
};



/**
 * Check if player has completed specific task
 * @param {string} taskId 
 * @param {object} playerData 
 * @returns 
 */
const checkIfGroupHasCompletedTask = (taskId, playerData) => {
	let groupHasCompletedTask = false;
	if (
		playerData.assignments &&
		playerData.assignments.some((a) => {return a.taskId === taskId;}) 
	) {
		const groupAssignmentData = playerData.assignments.find((a) => {return a.taskId === taskId;});
		if (
			groupAssignmentData.isCompleted === true	
		) {
			groupHasCompletedTask = true;
		}
	}

	return groupHasCompletedTask;
};

/**
 * Calculate number of errors
 * @param {string} type 
 * @param {array} attempts 
 * @returns 
 */
export function calculateErrors(type, attempts) {
	let errors = 0;

	if (type === 'input-answer') {
		errors = attempts.filter((a) => {return a.errors > 0;}).length;
	}

	if (
		type === 'multiple-choice' || 
		type === 'sort' || 
		type === 'paper-doll' ||
		type === 'spot-errors' ||
		type === 'pairs'
	) {
		errors = attempts[attempts.length - 1].errors;
	}

	if (type === 'order') {
		errors = attempts.length - 1;
	}

	return errors;
}

/**
 * Calculate points
 * @param {string} type 
 * @param {number} errors 
 * @param {number} maxPoints 
 * @param {object} taskAnswerData
 * @returns 
 */
export function calculatePoints(type, errors, maxPoints, taskAnswerData) {
	let points = (maxPoints ? maxPoints : defaultMaxPoints);

	/* Multiple choice / sort / order */
	if (
		type === 'multiple-choice' || 
		type === 'sort' || 
		type === 'order' || 
		type === 'paper-doll' ||
		type === 'spot-errors' ||
		type === 'pairs'
	) {
		points = points - errors * errorPenalty;
		points = Math.max(defaultMinPoints, points);
	}

	/* Multiple choice dilemma */
	if (type === 'multiple-choice-dilemma') {
		points = 0;
		if (taskAnswerData && taskAnswerData.specialPoints) points = taskAnswerData.specialPoints;
	}

	/* Input answer */
	if (type === 'input-answer') {
		if (errors < inputAnswerMaxAttempts) {
			points = points - errors * errorPenalty;
		} else {
			points = inputAnswerMinPoints;
		}
	}

	return points;
}


export {
	getScenarioTaskIds,
	getTaskData,
	checkIfGroupHasCompletedTask
};